// Friendly display names for the raw AI-engine keys the API returns
// (`google-aio`, `openai`, …). Pulled out of site-ai-visibility.tsx (Task 4,
// 2026-08-07 source-intelligence work) so the source-intelligence cards can
// share it without a route↔component circular import — this route was the
// only consumer before, so nothing else needed to change.

export const ENGINE_NAME: Record<string, string> = {
  'google-aio': 'Google AI',
  gemini: 'Gemini',
  openai: 'ChatGPT',
  perplexity: 'Perplexity',
  anthropic: 'Claude',
  copilot: 'Copilot',
  grok: 'Grok',
  deepseek: 'DeepSeek',
  meta: 'Meta AI',
};

export const ENGINE_ORDER = [
  'openai',
  'gemini',
  'perplexity',
  'google-aio',
  'anthropic',
  'copilot',
  'grok',
  'deepseek',
  'meta',
];

export function engineName(key: string): string {
  return ENGINE_NAME[key] ?? key;
}
